import BaseRepository from "../../../common/repository/base_repository";
import LoginModel from "../model/login_model";

export default class LoginRepository extends BaseRepository {

    itemUrl = '/api/login';
    modelClass = LoginModel;

}